import React from 'react'
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import { IdAutoCompleteField } from '../../shared/components/formfields/IdAutoCompleteField';
import { DateFormField } from '../../shared/components/formfields/DataFormField';
import { TimeFormField } from '../../shared/components/formfields/TimeFormFields';
import { Button, Grid2 } from '@mui/material';
import { sharedValidationSchema } from './SharedSchema';
import { useMutation } from '@tanstack/react-query';
import api from '../../assets/api/useStudentPostApi';
import { useToaster } from '../../shared/utils/ToasterProvider';
import { useEvents } from '../../assets/api/UseStudentGetApi';
import { useApartmentListForCourse } from '../../assets/api/useAdminApi';
import { Grid_Gap } from '../../shared/constants';
import { TextFormField } from '../../shared/components/formfields/TextFormField';
import CustomDivider from '../../shared/utils/CustomDivider';
const EventLinkForm = () => {
    const { data, fetchNextPage, hasNextPage, isLoading } = useEvents();
    const events = data?.pages.flatMap(page => page.data) || [];
    const EventOptions = events?.map((item) => ({
        id: item?.id,
        label: item?.event_name,
        value: item?.event_name,
    })) || []
    const { data: apartmentList, isLoading: isLoadingApartmentList } = useApartmentListForCourse();
    const ApartmentOptions = apartmentList?.data?.map((item) => ({
        id: item?.id,
        label: item?.apartment_name,
        value: item?.apartment_name,
    })) || [];
    const { showToaster } = useToaster();
    const validationSchema = Yup.object().shape({
        event_id: Yup.string().required("Course is required"),
        event_fees: Yup.number()
            .typeError("Price must be a number")
            .min(0, "Price must be 0 or greater")
            .required("Price is required"),
        ...sharedValidationSchema,
    });
    const initialValues = {
        event_id: null,
        apartments_id: null,
        start_date: null,
        end_date: null,
        start_time: null,
        end_time: null,
        event_fees: "",
    };

    const mutation = useMutation({
        mutationFn: (formData) => api.post("collab-event-apartment/create", formData),
    });
    const handleSubmit = (values, { setSubmitting, resetForm }) => {
        mutation.mutate(values, {
            onSuccess: (response) => {
                if (response?.data?.status === "success") {

                    showToaster('Success', response?.data?.message, 'success')
                } else {
                    showToaster('Error', "Something Went wrong", 'error')
                }
                resetForm();
            },
            onError: (error) => {
                showToaster('Error', "Something Went wrong", 'error')
            },
            onSettled: () => {
                setSubmitting(false);
            },
        });

    }
    return (
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
            {({ values,resetForm }) => (
                <Form>
                    <Grid2 container spacing={Grid_Gap}>
                        <Grid2 children size={{ xs: 12, sm: 4 }}>
                            <Field
                                name="event_id"
                                component={IdAutoCompleteField}
                                options={EventOptions}
                                label="Event"
                                isRequired={true}
                                isLoading={isLoading}
                            />
                        </Grid2>
                        <Grid2 children size={{ xs: 12, sm: 4 }}>
                            <Field
                                name="apartments_id"
                                component={IdAutoCompleteField}
                                options={ApartmentOptions}
                                label="Apartment"
                                isRequired={true}
                                isLoading={isLoadingApartmentList}
                            />
                        </Grid2>
                        <Grid2 children size={{ xs: 12, sm: 4 }}>
                            <Field
                                name="start_date"
                                component={DateFormField}
                                label="Start Date"
                                isRequired={true}
                                maxDate={values.end_date || undefined}
                            />
                        </Grid2>
                        <Grid2 children size={{ xs: 12, sm: 4 }}>
                            <Field
                                name="end_date"
                                component={DateFormField}
                                label="End Date"
                                isRequired={true}
                                minDate={values.start_date || undefined}
                            />
                        </Grid2>
                        <Grid2 children size={{ xs: 12, sm: 4 }}>
                            <Field
                                name="start_time"
                                component={TimeFormField}
                                label="Start Time"
                                isRequired={true}

                            />
                        </Grid2>
                        <Grid2 children size={{ xs: 12, sm: 4 }}>
                            <Field
                                name="end_time"
                                component={TimeFormField}
                                label="End Time"
                                isRequired={true}
                            />
                        </Grid2>

                        <Grid2 children size={{ xs: 12, sm: 4 }}>
                            <Field
                                name="event_fees"
                                component={TextFormField}
                                label="Price"
                                isRequired={true}
                                type={"number"}
                            />
                        </Grid2>

                    </Grid2>
                    <CustomDivider/>
                    <Grid2 container spacing={Grid_Gap} sx={{ display: "flex", justifyContent: "end" }}>
                        <Grid2 children size={{ xs: 12, sm: 3 }}>
                            <Button variant='outlined' fullWidth onClick={resetForm}>Cancel</Button>
                        </Grid2>
                        <Grid2 children size={{ xs: 12, sm: 3 }}>
                            <Button variant='contained' type="submit" fullWidth>Submit</Button>
                        </Grid2>
                    </Grid2>

                </Form>
            )}
        </Formik>
    )
}

export default EventLinkForm